module.exports = __webpack_public_path__ + "img/pgn09.831d502a.png";